export default "__VITE_ASSET__DoM2JZRE__"